// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ve70","right":"Footer_right__11PUa","buttons":"Footer_buttons__rIh-o"};